/**
 * Crea el reverso de la carta del tope del mazo
 * @param {*} scene 
 */
export function crearReversoCartaMazo(scene) {

  // Posición del reverso del mazo
  scene.reversoCartaMazo = scene.add.image(784, 56, "reversoCarta1");
  //scene.reversoCartaMazo.setDepth(0);
}